import { render, staticRenderFns } from "./approve-data.vue?vue&type=template&id=0a5a2b8c"
import script from "./approve-data.vue?vue&type=script&lang=js"
export * from "./approve-data.vue?vue&type=script&lang=js"
import style0 from "./approve-data.vue?vue&type=style&index=0&id=0a5a2b8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports